export function initializeShowroom(scope = document) {
  scope.querySelectorAll('[data-showroom-card]').forEach(card => {
    if (card.dataset.showroomReady) return;
    card.dataset.showroomReady = 'true';
    const buttons = [...card.querySelectorAll('[data-showroom-view]')];
    buttons.forEach(button => { button.disabled = false; });
    card.addEventListener('click', event => {
      const trigger = event.target.closest('[data-showroom-view]');
      if (!trigger || !card.contains(trigger)) return;
      const view = trigger.dataset.showroomView;
      if (!['model', 'front', 'product'].includes(view)) return;
      if (!card.querySelector('[data-showroom-pane="' + view + '"]')) return;
      let activePane;
      card.querySelectorAll('[data-showroom-pane]').forEach(pane => {
        pane.hidden = pane.dataset.showroomPane !== view;
        if (!pane.hidden) activePane = pane;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button === trigger)));
      const fullLink = card.querySelector('[data-showroom-full]');
      const source = activePane?.dataset.fullUrl;
      if (fullLink) {
        fullLink.hidden = !source;
        if (source) fullLink.href = source;
      }
      card.dataset.showroomActive = view;
    });
  });
}
if (typeof document !== 'undefined') {
  initializeShowroom();
  document.addEventListener('shopify:section:load', event => initializeShowroom(event.target));
}
